import { useState, Fragment, useEffect, useCallback } from "react";
import { Grid } from "@mui/material";
import { useParams, Link } from "react-router-dom";
import logo from "assets/img/Group-11.png";
import logoText from "assets/img/logotext.png";
import logoMain from "assets/img/logo.png";
import logoCenter from "assets/img/Group-11.png";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import InfoIcon from "@mui/icons-material/Info";
import { createPortal } from "react-dom";
import PersonIcon from "@mui/icons-material/Person";
import Divider from "@mui/material/Divider";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import {
  StyledPaper,
  StyledPaperIndex,
  StyledPaperDetail,
  StyledCircle,
  StyledButton,
  StyledLink,
  StyledLinkLogin,
  StyledLinkSpan,
  StyledMobileLogo,
  StyledMobileLogoDetail,
  StyledMobileImage2,
  StyledLinkcart,
  StyledLinkMobileIcon,
  StyledMenuItem,
  StyledDrawer,
  StyledTopMenu,
  StyledButtonIndex,
  StyledButtonIndexSearch,
  StyledIndexUl,
  StyledSearchContainer,
} from "./Menu.style";
import { Badge } from "@mui/material";
import SubMenu from "components/shared/SubMenu";
import {
  getCategorisFromSubMenuForAccessoryRequest,
  getCategorisFromSubMenuForFurnitureRequest,
  getStatusRequest,
} from "api/requests";
import useHttp from "hooks/use-http";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import useAuth from "hooks/use-auth";
import Search from "components/shared/Search/Search";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import ChairIcon from "@mui/icons-material/Chair";
import {
  MdCastForEducation,
  MdContactPhone,
  MdDescription,
} from "react-icons/md";
import { HiOutlineLogin } from "react-icons/hi";

export default function MenuCM(props) {
  const params = useParams();
  const AuthCTX = useAuth();
  const navigate = useNavigate();
  const { request, setLoading } = useHttp();
  const [selected, setSelected] = useState("");

  const [state, setState] = useState({
    bottom: false,
  });

  const [accessorycategoris, setAccessorycategoris] = useState({
    data: [],
    count: 0,
  });
  const [furniturecategoris, setFurniturecategoris] = useState({
    data: [],
    count: 0,
  });

  const [cartCount, setCartCount] = useState(0);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getStatus = useCallback(async () => {
    const res = await request({
      url: getStatusRequest,
    });
    setCartCount(res.cart_contents_count);
  }, [request]);

  useEffect(() => {
    if (AuthCTX.isLoggedIn) {
      getStatus();
    }
  }, []);

  const getCategorisForAccessory = useCallback(async () => {
    const res = await request({
      url: getCategorisFromSubMenuForAccessoryRequest,
    });
    setLoading(false);

    if (res) {
      if (res.count < 1) {
        return setAccessorycategoris({
          count: res.count,
          data: [{ content: " " }],
        });
      }

      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items.title,
      }));

      setAccessorycategoris({
        data: transformedData,
        count: res.count,
      });
    }
  }, [request, setLoading]);

  const getCategorisForFurniture = useCallback(async () => {
    const res = await request({
      url: getCategorisFromSubMenuForFurnitureRequest,
    });
    setLoading(false);

    if (res) {
      if (res.count < 1) {
        return setFurniturecategoris({
          count: res.count,
          data: [{ content: " " }],
        });
      }

      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items.title,
      }));

      setFurniturecategoris({
        data: transformedData,
        count: res.count,
      });
    }
  }, [request, setLoading]);

  ///////////////// Function Click Logo Go To Home Page ///////////////
  const handleClickNavigateHomePage = () => navigate("/");

  ///////////////// Get Categoris Title Array ///////////////
  // const getCategorisTitle = categoris.data.map((item) => item.title);

  useEffect(() => {
    getCategorisForAccessory();
    getCategorisForFurniture();
  }, [getCategorisForAccessory, getCategorisForFurniture]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const menulist = (
    <>
      <div>
        {!AuthCTX.isLoggedIn ? (
          <StyledLinkLogin to="/login">
            <StyledButton variant="outlined" style={{ marginRight: "10px" }}>
              {" "}
              ورود | ثبت نام{" "}
              <HiOutlineLogin
                style={{ fontSize: "20px", marginLeft: "10px" }}
              />
            </StyledButton>
          </StyledLinkLogin>
        ) : (
          <StyledLinkLogin to="/profile">
            <StyledButton variant="outlined" style={{ marginRight: "10px" }}>
              حساب کاربری{" "}
              <PersonIcon style={{ fontSize: "22px", marginLeft: "8px" }} />
            </StyledButton>
          </StyledLinkLogin>
        )}
        {["bottom"].map((anchor) => (
          <Fragment key={anchor}>
            <StyledButton
              onClick={toggleDrawer(anchor, true)}
              style={{ height: "41px" }}
            >
              <SearchIcon style={{ color: "white" }} />
            </StyledButton>
          </Fragment>
        ))}
      </div>

      <ul>
        <li style={{ padding: "0" }}>
          <StyledLinkSpan>
            <SubMenu
              categoris={furniturecategoris.data}
              selected={selected}
              setSelected={setSelected}
              link={"/Furniture"}
              menuTitle="مبلمان"
              menuTitleLink="/Furniture"
              ChairMenu
            />
          </StyledLinkSpan>
        </li>
        <li style={{ padding: "0" }}>
          <StyledLinkSpan>
            <SubMenu
              categoris={accessorycategoris.data}
              selected={selected}
              setSelected={setSelected}
              link={"/accessory"}
              menuTitle="اکسسوری"
              menuTitleLink="/accessory"
            />
          </StyledLinkSpan>
        </li>
        <li style={{ padding: "9px" }}>
          <StyledLink
            to="/article"
            style={{
              color: "white",
              display: "flex",
              alignItems: "center",
            }}
          >
            <MdCastForEducation
              style={{ fontSize: "17px", marginLeft: "10px" }}
            />{" "}
            اطلاعات تولید
          </StyledLink>
        </li>
        <li style={{ padding: "9px" }}>
          <StyledLink
            to="/aboutus"
            style={{
              color: "white",
              display: "flex",
              alignItems: "center",
            }}
          >
            <MdDescription style={{ fontSize: "18px", marginLeft: "10px" }} />{" "}
            درباره ما
          </StyledLink>
        </li>
        <li style={{ padding: "9px" }}>
          <StyledLink
            to="/contact"
            style={{
              color: "white",
              display: "flex",
              alignItems: "center",
            }}
          >
            <MdContactPhone style={{ fontSize: "18px", marginLeft: "10px" }} />{" "}
            تماس با ما
          </StyledLink>
        </li>
      </ul>
      <StyledMobileLogoDetail
        src={logo}
        alt="logo"
        onClick={handleClickNavigateHomePage}
      />

      <StyledMobileImage2
        src={logoCenter}
        alt="logo"
        onClick={handleClickNavigateHomePage}
      />
      <StyledLinkMobileIcon>
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={open ? "long-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MenuIcon style={{ color: "white" }} />
        </IconButton>
        <Menu
          id="long-menu"
          MenuListProps={{
            "aria-labelledby": "long-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: "159px",
              width: "20ch",
            },
          }}
        >
          <StyledMenuItem onClick={handleClose}>
            <Link to="/article">
              <NewspaperIcon /> <span>اطلاعات تولید</span>
            </Link>
          </StyledMenuItem>
          <StyledMenuItem onClick={handleClose}>
            <Link to="/aboutus">
              <ContactPhoneIcon /> <span>درباره ما</span>
            </Link>
          </StyledMenuItem>
          <StyledMenuItem onClick={handleClose}>
            <Link to="/contact">
              <InfoIcon /> <span>ارتباط با ما</span>
            </Link>
          </StyledMenuItem>
        </Menu>
      </StyledLinkMobileIcon>
    </>
  );

  const menulistIndex = (
    <>
      <StyledTopMenu>
        {!AuthCTX.isLoggedIn ? (
          <StyledLinkLogin to="/login">
            <StyledButtonIndex
              variant="outlined"
              style={{ marginRight: "10px" }}
            >
              {" "}
              ورود | ثبت نام{" "}
              <HiOutlineLogin
                style={{ fontSize: "20px", marginLeft: "10px" }}
              />
            </StyledButtonIndex>
          </StyledLinkLogin>
        ) : (
          <StyledLinkLogin to="/profile">
            <StyledButtonIndex
              variant="outlined"
              style={{ marginRight: "10px" }}
            >
              حساب کاربری{" "}
              <PersonIcon style={{ fontSize: "22px", marginLeft: "8px" }} />
            </StyledButtonIndex>
          </StyledLinkLogin>
        )}
        <StyledSearchContainer>
          {["bottom"].map((anchor) => (
            <Fragment key={anchor}>
              <StyledButtonIndexSearch onClick={toggleDrawer(anchor, true)}>
                <span>
                  {params.searchText ? params.searchText : " جستجو   "}
                </span>
                <SearchIcon style={{ color: "#787991" }} />
              </StyledButtonIndexSearch>
            </Fragment>
          ))}
          <StyledMobileLogo
            // src={logoText}
            src={logoMain}
            alt="logo"
            onClick={handleClickNavigateHomePage}
          />
        </StyledSearchContainer>

        <StyledMobileImage2
          src={logoMain}
          alt="logo"
          onClick={handleClickNavigateHomePage}
        />
        <StyledLinkMobileIcon>
          <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={open ? "long-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-haspopup="true"
            onClick={handleClick}
          >
            <MenuIcon style={{ color: "black" }} />
          </IconButton>
          <Menu
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              style: {
                maxHeight: "159px",
                width: "20ch",
              },
            }}
          >
            <StyledMenuItem onClick={handleClose}>
              <Link to="/article">
                <NewspaperIcon /> <span>اطلاعات تولید</span>
              </Link>
            </StyledMenuItem>
            <StyledMenuItem onClick={handleClose}>
              <Link to="/aboutus">
                <ContactPhoneIcon /> <span>درباره ما</span>
              </Link>
            </StyledMenuItem>
            <StyledMenuItem onClick={handleClose}>
              <Link to="/contact">
                <InfoIcon /> <span>ارتباط با ما</span>
              </Link>
            </StyledMenuItem>
          </Menu>
        </StyledLinkMobileIcon>
      </StyledTopMenu>
      <StyledIndexUl>
        <ul>
          <li style={{ padding: "0" }}>
            <StyledLinkSpan>
              <SubMenu
                categoris={furniturecategoris.data}
                selected={selected}
                setSelected={setSelected}
                link={"/Furniture"}
                menuTitle="مبلمان"
                menuTitleLink="/Furniture"
                ChairMenu
                color="black"
              />
            </StyledLinkSpan>
          </li>
          <li style={{ padding: "0" }}>
            <StyledLinkSpan>
              <SubMenu
                categoris={accessorycategoris.data}
                selected={selected}
                setSelected={setSelected}
                link={"/accessory"}
                menuTitle="اکسسوری"
                menuTitleLink="/accessory"
                color="black"
              />
            </StyledLinkSpan>
          </li>
          <li style={{ padding: "9px" }}>
            <StyledLink
              to="/article"
              style={{
                color: "rgb(74, 76, 100)",
                display: "flex",
                alignItems: "center",
              }}
            >
              <MdCastForEducation
                style={{ fontSize: "18px", marginLeft: "10px" }}
              />{" "}
              اطلاعات تولید
            </StyledLink>
          </li>
          <li style={{ padding: "9px" }}>
            <StyledLink
              to="/aboutus"
              style={{
                color: "rgb(74, 76, 100)",
                display: "flex",
                alignItems: "center",
              }}
            >
              <MdDescription style={{ fontSize: "18px", marginLeft: "10px" }} />{" "}
              درباره ما
            </StyledLink>
          </li>
          <li style={{ padding: "9px" }}>
            <StyledLink
              to="/contact"
              style={{
                color: "rgb(74, 76, 100)",
                display: "flex",
                alignItems: "center",
              }}
            >
              <MdContactPhone
                style={{ fontSize: "18px", marginLeft: "10px" }}
              />{" "}
              تماس با ما
            </StyledLink>
          </li>
        </ul>
      </StyledIndexUl>
    </>
  );

  return createPortal(
    <Fragment>
      <Grid item xs={12}>
        <Grid item xs={12}>
          {props.IndexMenu ? (
            <StyledPaperIndex elevation={0}>{menulistIndex}</StyledPaperIndex>
          ) : props.Detail ? (
            <StyledPaperDetail elevation={0}>{menulist}</StyledPaperDetail>
          ) : (
            <StyledPaper elevation={0}>
              {menulist}
              <h1>{props.pageTitle && props.pageTitle}</h1>
              <h4>{props.pageCategory && props.pageCategory}</h4>
            </StyledPaper>
          )}
          {AuthCTX.isLoggedIn ? (
            <StyledLinkcart to="/shoppingCart">
              {cartCount !== "0" ? (
                <Badge
                  color="warning"
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  badgeContent={cartCount}
                >
                  <ShoppingCartIcon />
                </Badge>
              ) : (
                <Badge
                  color="warning"
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <ShoppingCartIcon />
                </Badge>
              )}
            </StyledLinkcart>
          ) : (
            ""
          )}
        </Grid>
        {props.Circle && <StyledCircle></StyledCircle>}
      </Grid>

      {["bottom"].map((anchor) => (
        <Fragment key={anchor}>
          {/* <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button> */}
          <StyledDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            <Search Close={toggleDrawer(anchor, false)} />
          </StyledDrawer>
        </Fragment>
      ))}
    </Fragment>,
    document.getElementById("header")
  );
}
